import { typeSelectDataForPublishedProducts } from '@/helpers/server/published-products-select-data';

export const checkIsBuilderProduct = (
  item: any,
  selectDataForPublishedProducts?: typeSelectDataForPublishedProducts,
  locale: string = 'au'
): boolean => {
  const itemCode = item?.variant?.attributes?.['item-code'] || item?.variant?.sku;

  // 1. Check current published products as source of truth if available
  if (selectDataForPublishedProducts && itemCode) {
    const selectDataLocaleSpecific =
      locale === 'au' || locale === 'en-AU'
        ? selectDataForPublishedProducts?.dataAU
        : selectDataForPublishedProducts?.dataNZ;

    const parentProduct = selectDataLocaleSpecific?.find((element: any) =>
      element.variants?.some((variant: any) => variant.key === itemCode || variant.sku === itemCode)
    );

    if (parentProduct) {
      const parentVariant = parentProduct.variants?.find(
        (v: any) => v.key === itemCode || v.sku === itemCode
      ) || parentProduct.variants?.[0];

      const parentAttributes = parentVariant?.attributes || parentProduct?.attributes || {};
      const builderRangeVal = parentAttributes['builder-range'];

      if (builderRangeVal) {
        if (typeof builderRangeVal === 'string' && builderRangeVal.toLowerCase() === 'yes') {
          return true;
        }
        if (typeof builderRangeVal === 'boolean' && builderRangeVal) {
          return true;
        }
        if (typeof builderRangeVal === 'object' && builderRangeVal !== null) {
          const val = builderRangeVal['en-AU'] || builderRangeVal['en-NZ'] || Object.values(builderRangeVal)[0];
          if (typeof val === 'string' && (val as string).toLowerCase() === 'yes') {
            return true;
          }
        }
      }
      if (parentProduct.isBuilderRange) return true;
    }
  }

  // 2. Fallback to item.variant attributes (snapshot data)
  const attributes = item?.variant?.attributes || {};
  const builderAttr = attributes['builder-range'];
  if (builderAttr) {
    if (typeof builderAttr === 'string' && builderAttr.toLowerCase() === 'yes') {
      return true;
    }
    if (typeof builderAttr === 'boolean' && builderAttr) {
      return true;
    }
    if (typeof builderAttr === 'object' && builderAttr !== null) {
      const val = builderAttr['en-AU'] || builderAttr['en-NZ'] || Object.values(builderAttr)[0];
      if (typeof val === 'string' && (val as string).toLowerCase() === 'yes') {
        return true;
      }
    }
  }

  // 3. Fallback to item-attributes array
  const itemAttributes = attributes['item-attributes'] || [];
  const itemAttrBuilder = itemAttributes.find((attr: any) => attr.name === 'builder-range')?.value;
  if (itemAttrBuilder) {
    if (typeof itemAttrBuilder === 'string' && itemAttrBuilder.toLowerCase() === 'yes') {
      return true;
    }
    if (typeof itemAttrBuilder === 'boolean' && itemAttrBuilder) {
      return true;
    }
    if (typeof itemAttrBuilder === 'object' && itemAttrBuilder !== null) {
      const val = itemAttrBuilder['en-AU'] || itemAttrBuilder['en-NZ'] || Object.values(itemAttrBuilder)[0];
      if (typeof val === 'string' && (val as string).toLowerCase() === 'yes') {
        return true;
      }
    }
  }

  // 4. Fallback to direct isBuilderRange flag
  if (item?.variant?.isBuilderRange || item?.isBuilderRange) {
    return true;
  }

  return false;
};